import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const OrganisationDetailsPanelOrganisationFragmentDoc = gql`
  fragment OrganisationDetailsPanelOrganisation on OrganisationInterface {
    id
    parent {
      id
      name
    }
    legalEntity
    createdAt
    isASupplier
    isVerified
    owner {
      id
      name
    }
    nearestLegalEntity {
      id
      name
    }
  }
` as unknown as DocumentNode<Types.OrganisationDetailsPanelOrganisationFragment, unknown>
